import {
  SHOW_SHORTCUTS_BEGIN,
  SHOW_SHORTCUTS_FAILURE,
  SHOW_SHORTCUTS_SUCCESS,
} from "actions/1_ActionConstants";

const initialState = {
  loading: false,
  error: null,
  shortcuts: {
    visible: false,
    access: false,
  },
};

export default function ShowShortcutsReducers(state = initialState, action) {
  switch (action.type) {
    case SHOW_SHORTCUTS_BEGIN:
      return {
        ...state,
      };

    case SHOW_SHORTCUTS_SUCCESS:
      return {
        ...state,
        loading: false,
        shortcuts: action.payload,
      };

    case SHOW_SHORTCUTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: "FAILED TO LOAD,..,.", //action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
}
